import * as React from "react";
import { forwardRef } from "react";
const SvgLighteningBolt = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.8333 0.833313L5 11.6666H10V19.1666L15.8333 8.33331H10.8333V0.833313Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgLighteningBolt);
export default ForwardRef;
